// if (document.querySelectorAll('.swiper__container').length) {
	// 	document.querySelectorAll('.swiper__container').forEach((gallery) => {

	// 		const gallerySlider = gallery.querySelector('.gallery-slider');
	// 		const btnPrev = gallery.querySelector('.swiper-button-prev');
	// 		const btnNext = gallery.querySelector('.swiper-button-next');

	// 		gallerySlider
	// 			.querySelectorAll('.swiper-slide-blank')
	// 			.forEach((el) => el.remove());

	// 		const slidesLength =
	// 			gallerySlider.querySelectorAll('.swiper-slide').length;
	// 		let realIdx = 0;

	// 		const swiper = new Swiper(gallerySlider, {
	// 			// loop: true,  // wyłączyłam bo loop nie działa poprawnie z wersją gridową swipera :(
	// 			// loopedSlides: slidesLength, 
	// 			// loopFillGroupWithBlank: true, 
	// 			grabCursor: true,
	// 			resizeObserver: true,
	// 			updateOnWindowResize: true,
	// 			slidesPerView: 5,
	// 			loop: true,

	// 			grid: {
	// 				rows: 4,
	// 				fill: 'row',
	// 			},
	// 			breakpoints: {
	// 				0: {
	// 					slidesPerView: 5,
	// 					grid: {
	// 						rows: 5,
	// 						fill: 'row',
	// 					},
	// 				},

	// 				800: {
	// 					slidesPerView: 8,
	// 					grid: {
	// 						rows: 4,
	// 						fill: 'row',
	// 					},
	// 				}
	// 			},
	// 			navigation: {
	// 				nextEl: btnNext,
	// 				prevEl: slidesLength > 1 ? btnPrev : null,
	// 			},
	// 			on: {
	// 				realIndexChange() {
	// 					const eventAction =
	// 						'ontouchstart' in document.documentElement ? 'tap' : 'click';
	// 					const evType = this.swipeDirection ? 'swipe' : eventAction;
	// 					const item = this.el.querySelector(
	// 						`[data-swiper-slide-index="${this.el.swiper.realIndex}"]`
	// 					);
	// 					statsOnWidgetInteraction(
	// 						item,
	// 						item.querySelector('img')?.getAttribute('src'),
	// 						this.el.swiper.realIndex,
	// 						evType
	// 					);
	// 					realIdx = this.realIndex;
	// 				},
	// 			},
	// 		});

	// 	});
	// }


// import { statsOnWidgetInteraction } from "../stats";

// export function sliderSwiper() {
//   function buildSwiperColumns() {
//     const container = document.querySelector(".gallery-slider .swiper-wrapper");
//     if (!container) return 0;

//     const rawSlides = [...container.querySelectorAll(".swiper-slide")];
//     const backendBlanks = [
//       ...container.querySelectorAll(".swiper__item.widget__item.__blank"),
//     ];

//     const defaultBlank =
//       `<div class="swiper__item widget__item __blank"><span>Brand Studio</span></div>`;

//     // Zdjęcia
//     const photos = rawSlides
//       .map((el) => {
//         const img = el.querySelector("img");
//         return img
//           ? `<div class="swiper__item"><img src="${img.src}" alt="${img.alt}" /></div>`
//           : null;
//       })
//       .filter(Boolean);

//     // Slajdy blank (kolejność zachowana!)
//     let blanks = backendBlanks.map((el) => el.outerHTML);
//     if (blanks.length === 0) blanks = [defaultBlank];

//     // Połącz zdjęcia + blanki
//     let allItems = [...photos, ...blanks];

//     // Dopełnienie do wielokrotności 4
//     const remainder = allItems.length % 4;
//     if (remainder !== 0) {
//       const needed = 4 - remainder;
//       const addIndices = [-2, -3, -4];
//       for (let i = 0; i < needed; i++) {
//         const idx = addIndices[i];
//         if (blanks[blanks.length + idx]) {
//           allItems.push(blanks[blanks.length + idx]);
//         } else {
//           console.warn("%cza mało działów", "color:red;font-weight:bold;");
//           allItems.push(defaultBlank);
//         }
//       }
//     }

//     const photoItems = allItems.filter((x) => !x.includes("__blank"));
//     const blankItems = allItems.filter((x) => x.includes("__blank"));

//     const totalSlots = photoItems.length + blankItems.length;
//     const totalCols = Math.ceil(totalSlots / 4);

//     const grid = Array.from({ length: totalCols }, () => Array(4).fill(null));

//     const usedPositions = new Set();

//     blankItems.forEach((blank) => {
//       let placed = false;
//       let attempts = 0;

//       while (!placed && attempts < 100) {
//         const col = Math.floor(Math.random() * totalCols);
//         const row = Math.floor(Math.random() * 4);
//         const posKey = `${col}-${row}`;

//         // Sprawdzenie warunków
//         const colHasBlank = grid[col].some((x) => x && x.includes("__blank"));
//         const leftBlank =
//           col > 0 && grid[col - 1][row] && grid[col - 1][row].includes("__blank");
//         const rightBlank =
//           col < totalCols - 1 &&
//           grid[col + 1][row] &&
//           grid[col + 1][row].includes("__blank");

//         // ❗ NOWY WARUNEK → pierwsza i ostatnia kolumna nie mogą mieć blank na tej samej pozycji
//         const firstLastConflict =
//           (col === 0 &&
//             grid[totalCols - 1][row] &&
//             grid[totalCols - 1][row].includes("__blank")) ||
//           (col === totalCols - 1 &&
//             grid[0][row] &&
//             grid[0][row].includes("__blank"));

//         if (
//           !colHasBlank &&
//           !leftBlank &&
//           !rightBlank &&
//           !usedPositions.has(posKey) &&
//           !firstLastConflict
//         ) {
//           grid[col][row] = blank;
//           usedPositions.add(posKey);
//           placed = true;
//         }
//         attempts++;
//       }

//       if (!placed) {
//         console.warn(
//           "%cza mało zdjęć aby rozmieścić działy tak aby nie były obok siebie",
//           "color:red;font-weight:bold;"
//         );
//         for (let c = 0; c < totalCols && !placed; c++) {
//           for (let r = 0; r < 4 && !placed; r++) {
//             if (!grid[c][r]) {
//               grid[c][r] = blank;
//               placed = true;
//             }
//           }
//         }
//       }
//     });

//     // Uzupełnianie zdjęciami
//     let photoIdx = 0;
//     for (let c = 0; c < totalCols; c++) {
//       for (let r = 0; r < 4; r++) {
//         if (!grid[c][r]) {
//           if (photoIdx < photoItems.length) {
//             grid[c][r] = photoItems[photoIdx++];
//           } else {
//             grid[c][r] = defaultBlank;
//           }
//         }
//       }
//     }

//     const htmlCols = grid.map(
//       (col) => `<div class="swiper-slide column">${col.join("")}</div>`
//     );

//     container.innerHTML = htmlCols.join("");
//     return htmlCols.length;
//   }



export function sliderSwiper() {
  function buildSwiperColumns() {
    const container = document.querySelector(".gallery-slider .swiper-wrapper");
    if (!container) return 0;

    const rawSlides = [...container.querySelectorAll(".swiper-slide")];
    const backendBlanks = [
      ...container.querySelectorAll(".swiper__item.widget__item.__blank"),
    ];

    const defaultBlank =
      `<div class="swiper__item widget__item __blank"><span>Brand Studio</span></div>`;

    const photos = rawSlides
      .map((el) => {
        const img = el.querySelector("img");
        return img
          ? `<div class="swiper__item"><img src="${img.src}" alt="${img.alt}" /></div>`
          : null;
      })
      .filter(Boolean);

    let blanks = backendBlanks.map((el) => el.outerHTML);
    if (blanks.length === 0) blanks = [defaultBlank];

    // łączna liczba elementów
    let totalItems = photos.length + blanks.length;

    // dopełnienie do wielokrotności 4
    const remainder = totalItems % 4;
    const slotsNeeded = remainder === 0 ? 0 : 4 - remainder;
    totalItems += slotsNeeded;

    const totalCols = Math.ceil(totalItems / 4);

    // Budowanie pustej siatki 
    const grid = Array.from({ length: totalCols }, () => Array(4).fill("photo"));

    // rezerwacja miejsc na blanki 
    let reservedBlanks = new Set();

    const reserveBlank = (col, row) => {
      grid[col][row] = "blank";
      reservedBlanks.add(`${col}-${row}`);
    };

    let blanksToPlace = blanks.length + slotsNeeded;

    let attempts = 0;
    while (blanksToPlace > 0 && attempts < 200) {
      attempts++;
      const col = Math.floor(Math.random() * totalCols);
      const row = Math.floor(Math.random() * 4);

      if (grid[col].includes("blank")) continue; // max 1 blank na kolumnę
      if (reservedBlanks.has(`${col}-${row}`)) continue;

      const left = col > 0 && reservedBlanks.has(`${col - 1}-${row}`);
      const right =
        col < totalCols - 1 && reservedBlanks.has(`${col + 1}-${row}`);
      const firstLast =
        (col === 0 && reservedBlanks.has(`${totalCols - 1}-${row}`)) ||
        (col === totalCols - 1 && reservedBlanks.has(`0-${row}`));

      if (!left && !right && !firstLast) {
        reserveBlank(col, row);
        blanksToPlace--;
      }
    }

    if (blanksToPlace > 0) {
      console.warn(
        "%cza mało zdjęć aby rozmieścić działy tak aby nie były obok siebie",
        "color:red;font-weight:bold;"
      );
    }

    // --- Wypełnianie zdjęciami i blankami ---
    let photoIdx = 0;
    let blankIdx = 0;

    const getBlank = () => {
      if (blankIdx < blanks.length) return blanks[blankIdx++];
      const fallbackIdx = [-6, -5, -4][blankIdx - blanks.length] || -3;
      if (blanks.at(fallbackIdx)) {
        blankIdx++;
        return blanks.at(fallbackIdx);
      }
      console.warn("%cza mało działów", "color:red;font-weight:bold;");
      return defaultBlank;
    };

    const htmlCols = grid.map((col) => {
      const inner = col
        .map((slot) => {
          if (slot === "blank") return getBlank();
          if (photoIdx < photos.length) return photos[photoIdx++];
          return defaultBlank;
        })
        .join("");

      return `<div class="swiper-slide column">${inner}</div>`;
    });

    container.innerHTML = htmlCols.join("");
    return htmlCols.length;
  }


  document.addEventListener("DOMContentLoaded", () => {
    const totalSlides = buildSwiperColumns(); // <- pobieramy liczbę kolumn
	
    const swiper = new Swiper(".gallery-slider", {
      loop: true,
      loopedSlides: totalSlides,
      slidesPerView: 7,
      slidesPerGroup: 1,
      grabCursor: true,
      breakpoints: {
        0: {
          slidesPerView: 3.2,          
          centeredSlides: true,          
		  loopedSlides: totalSlides, 
		  centerInsufficientSlides: true,
        },
        640: {
          slidesPerView: 7,          
          centeredSlides: false,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
	// Naprawa błędu Swipera z niewidocznymi slajdami przy loop
  	swiper.on("loopFix", () => swiper.update());
	swiper.on("init", () => {
	swiper.updateSlides();
		swiper.slideToLoop(0, 0); // zaczynamy od pierwszego slajdu w pętli
	});
	swiper.on("afterInit", () => {
		swiper.slideToLoop(0, 0); // zacznij od pierwszego slajdu w pętli
	});
	window.addEventListener("resize", () => {
		swiper.update();
		swiper.slideToLoop(swiper.realIndex, 0); // trzyma aktywny slajd na środku
	});
	swiper.init();
  });
}
